export const CREATE_CHANGE_TECHNOLOGY = 'OVID/CHANGE_TECHNOLOGY/CREATE'
export const CREATE_CHANGE_TECHNOLOGY_SUCCESS = 'OVID/CHANGE_TECHNOLOGY/CREATED'
export const CREATE_CHANGE_TECHNOLOGY_FAILED = 'OVID/CHANGE_TECHNOLOGY/CREATE_FAILED'
export const CHANGE_TECHNOLOGY_SAVE_OPERATION_DATA = 'OVID/CHANGE_TECHNOLOGY/SAVE_OPERATION_DATA'
export const xDSLs = ['xDSL', 'adsl', 'ADSL']
export const BUSSINESS_TYPE_RULES = ['neba', 'cangas', 'vula']
